<template>
  <v-row>
    <!-- header -->
    <mini-header title="SIRE" :dense="true" :breadcrumbs="breadcrumbs" :hiddenTab="true" />
    <!-- end header -->
    <PermissionDenied v-if="!$helpers.hasSomePermission(['view_reports'])" />
     <template v-else>
      <div class="subtitle-2  grey-700--text font-weight-semibold">Elija el reporte que desea descargar</div>
      <v-col cols="12" class="px-0 mt-5">
        <v-row no gutters>
          <v-col cols="3" v-for="(report, i) in reportsList" :key="i">
            <v-card class="px-5 py-7" @click="reportDialog=true, selectedReport=report" height="80" min-width="190">
              <v-row class="fill-height ma-0 text-left" align="center">
                <v-img contain :height="44" style="position: absolute" :src="require(`@/assets/shortcuts-icons/avatars/${report.icon}--avatar.svg`)" />
                <span class="grey-700--text font-weight-bold ml-14 pl-2" :class="$vuetify.breakpoint.width <= 1200 ? 'body-2' : 'subtitle-2'" style="line-height: normal" >{{ report.title }}</span>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </template>
    <!-- dialog report -->
    <v-dialog v-model="reportDialog" width="730" persistent no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">Fecha del reporte</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="closeReportDialog" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4 px-5 grey-500--text">
          <v-row class="pt-2 pb-4" align="center">
            <v-col cols="3">
              <img :src="require(`@/assets/backgrounds/modal-mode.svg`)" :width="180" />
            </v-col>
            <v-col class="pr-4 pl-12">
              <div class="subtitle-2 grey-700--text font-weight-semibold">Ingrese la fecha del reporte</div>
              <span class="d-block body-1 py-3">
                Por favor ingrese el <span class="font-weight-semibold">MES-AÑO</span> del reporte que requiere en el formato <span class="font-weight-semibold">AAAA-MM</span>. Por ejemplo, para recuperar un reporte de octubre de 2025, debe ingresar <span class="font-weight-semibold">2025-10</span>.
              </span>
              <v-text-field
                ref="dateInput"
                v-model="dateReport"
                outlined
                single-line
                maxlength="7"
                dense
                hide-details
                :rules="[dateReportRule]"
                @input="formatDateInput"
                @keyup.enter="handleEnterKey"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn @click="closeReportDialog" outlined>Cancelar</v-btn>
          <v-btn color="blue-500" :disabled="!isValidDateReport" @click="downloadReport" :loading="loading">Descargar reporte</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog report -->
  </v-row>
</template>
<script>
import { saveAs } from 'file-saver'
import MiniHeader from '@/components/commons/MiniHeader'
import PermissionDenied from '@/modules/http/views/PermissionDenied'
import SkeletonList from '@/components/commons/skeletonLoader/SkeletonList'
import VEmptyState from '@/components/commons/VEmptyState'

export default {
  components: {
    MiniHeader,
    PermissionDenied,
    SkeletonList,
    VEmptyState
  },
  data () {
    return {
      dateReport: null,
      reportDialog: false,
      loading: false,
      breadcrumbs: {
        main: 'Emisión',
        children: [
          {
            text: 'Reportes'
          }
        ]
      },
      selectedReport: null,
      allReports: [
        {
          title: 'Libro de ventas',
          icon: 'documents',
          report_type: 'SAL'
        },
        {
          title: 'Resumen de emisión',
          icon: 'documents',
          report_type: 'ISU'
        },
        {
          title: 'Reporte de distribución',
          icon: 'documents',
          report_type: 'DST'
        },
        {
          title: 'Resumen de distribución',
          icon: 'documents',
          report_type: 'DSR',
          workspaces: ['cl-nvn']
        },
        {
          title: 'Resumen de recepción',
          icon: 'documents',
          report_type: 'REC'
        },
        {
          title: 'Reporte MOP I10',
          icon: 'documents',
          report_type: 'IFE'
        },
        {
          title: 'Reporte MOP I12',
          icon: 'documents',
          report_type: 'IFD'
        },
        {
          title: 'Reporte de rebotes',
          icon: 'documents',
          report_type: 'DSB'
        }
      ]
    }
  },
  computed: {
    reportsList () {
      const workspace = this.$store.state.auth.account.acc_id
      return this.allReports.filter(report => !report.workspaces || report.workspaces.includes(workspace))
    },
    isValidDateReport () {
      if (!this.dateReport) return false

      const dateRegex = /^\d{4}-\d{2}$/
      if (!dateRegex.test(this.dateReport)) return false

      const [year, month] = this.dateReport.split('-')
      const yearNum = parseInt(year)
      const monthNum = parseInt(month)

      return yearNum >= 2000 && yearNum <= 2100 && monthNum >= 1 && monthNum <= 12
    }
  },
  methods: {
    closeReportDialog () {
      this.reportDialog = false
      this.dateReport = null
      this.selectedReport = null
      this.$nextTick(() => {
        if (this.$refs.dateInput) {
          this.$refs.dateInput.resetValidation()
        }
      })
    },

    handleEnterKey () {
      if (this.isValidDateReport && !this.loading) {
        this.downloadReport()
      }
    },

    // Validación del formato YYYY-MM
    dateReportRule (value) {
      if (!value) return 'La fecha es requerida'

      const dateRegex = /^\d{4}-\d{2}$/
      if (!dateRegex.test(value)) {
        return 'Formato inválido. Use YYYY-MM (ej: 2025-09)'
      }

      const [year, month] = value.split('-')
      const yearNum = parseInt(year)
      const monthNum = parseInt(month)

      if (yearNum < 2000 || yearNum > 2100) {
        return 'El año debe estar entre 2000 y 2100'
      }

      if (monthNum < 1 || monthNum > 12) {
        return 'El mes debe estar entre 01 y 12'
      }

      return true
    },

    // Formatear el input mientras el usuario escribe
    formatDateInput (value) {
      let formatted = value.replace(/[^\d-]/g, '')
      if (formatted.length > 4 && !formatted.includes('-')) {
        formatted = formatted.substring(0, 4) + '-' + formatted.substring(4)
      }

      if (formatted.length > 7) {
        formatted = formatted.substring(0, 7)
      }

      this.dateReport = formatted
    },

    downloadReport () {
      this.loading = true
      this.$store.dispatch('accounts/LIST', {
        resource: `reports/download/tag`,
        query: {
          report_type: this.selectedReport.report_type,
          year_month: this.dateReport,
          is_full_month: true
        },
        responseType: 'blob'
      })
      .then((response) => {
        const contentDisposition = response.headers['content-disposition']
        let filename = `${this.selectedReport.title}-${this.dateReport}.zip` // nombre por defecto

        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '')
          }
        }

        const blob = new Blob([response.data], {
          type: 'application/zip'
        })

        saveAs(blob, filename)

        this.$dialog.message.info('El reporte se ha descargado con éxito.')
        this.closeReportDialog()
      })
      .catch(() => {
        this.$dialog.message.error(`El reporte solicitado no está disponible para la fecha ingresada`, { timeout: 10000 })
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>